/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddressIssueDTOFromJSON, AddressIssueDTOToJSON, } from './AddressIssueDTO';
import { SubmissionBlockerFromJSON, SubmissionBlockerToJSON, } from './SubmissionBlocker';
/**
 * @export
 */
export const ExtensionOrderImportResultDTOOutcomeEnum = {
    Updated: 'UPDATED',
    NotFound: 'NOT_FOUND',
    Unchanged: 'UNCHANGED',
    SkippedAlreadySubmitted: 'SKIPPED_ALREADY_SUBMITTED'
};
/**
 * Check if a given object implements the ExtensionOrderImportResultDTO interface.
 */
export function instanceOfExtensionOrderImportResultDTO(value) {
    return true;
}
export function ExtensionOrderImportResultDTOFromJSON(json) {
    return ExtensionOrderImportResultDTOFromJSONTyped(json, false);
}
export function ExtensionOrderImportResultDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'outcome': json['outcome'] == null ? undefined : json['outcome'],
        'submissionBlockers': json['submissionBlockers'] == null ? undefined : (json['submissionBlockers'].map(SubmissionBlockerFromJSON)),
        'addressIssues': json['addressIssues'] == null ? undefined : (json['addressIssues'].map(AddressIssueDTOFromJSON)),
    };
}
export function ExtensionOrderImportResultDTOToJSON(json) {
    return ExtensionOrderImportResultDTOToJSONTyped(json, false);
}
export function ExtensionOrderImportResultDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderId': value['orderId'],
        'outcome': value['outcome'],
        'submissionBlockers': value['submissionBlockers'] == null ? undefined : (value['submissionBlockers'].map(SubmissionBlockerToJSON)),
        'addressIssues': value['addressIssues'] == null ? undefined : (value['addressIssues'].map(AddressIssueDTOToJSON)),
    };
}
